// test642
(642 && 0);
